module.exports = __webpack_public_path__ + "img/x-circle.c89cb7d9.svg";